"use strict";
var Rect_1 = require('./Rect');
function createTiledImage(img) {
    var p = img.width / 2;
    var canvas = document.createElement('canvas');
    canvas.id = img.id || '';
    canvas.width = img.width + img.width;
    canvas.height = img.height + img.height;
    var context = canvas.getContext('2d');
    var pattern = context.createPattern(img, 'repeat');
    context.fillStyle = pattern;
    context.translate(p, p);
    context.fillRect(-p, -p, canvas.width + p, canvas.height + p);
    context.translate(-p, -p);
    return canvas;
}
function makeUv(node, tilepad, w, h) {
    var p = tilepad ? node.rect.w / 4 : 0;
    return [
        [node.rect.x + p, node.rect.y + p],
        [(node.rect.x + p) + (node.rect.w - (p * 2)), node.rect.y + p],
        [(node.rect.x + p) + (node.rect.w - (p * 2)), (node.rect.y + p) + (node.rect.h - (p * 2))],
        [(node.rect.x + p), (node.rect.y + p) + (node.rect.h - (p * 2))],
    ].map(function (uv) {
        if (uv[0] !== 0) {
            uv[0] = uv[0] / w;
        }
        if (uv[1] !== 0) {
            uv[1] = uv[1] / h;
        }
        return uv;
    });
}
function makeUv2(node, tilepad, w, h) {
    var p = tilepad ? node.rect.w / 4 : 0;
    var uv = new Float32Array(8);
    uv[0] = (node.rect.x + p) / w;
    uv[1] = (node.rect.y + p) / h;
    uv[2] = ((node.rect.x + p) + (node.rect.w - (p * 2))) / w;
    uv[3] = (node.rect.y + p) / h;
    uv[4] = ((node.rect.x + p) + (node.rect.w - (p * 2))) / w;
    uv[5] = ((node.rect.y + p) + (node.rect.h - (p * 2))) / h;
    uv[6] = (node.rect.x + p) / w;
    uv[7] = ((node.rect.y + p) + (node.rect.h - (p * 2))) / h;
    return uv;
}
var AtlasNode = (function () {
    function AtlasNode(x, y, w, h) {
        this.left = this.right = null;
        this.rect = new Rect_1.default(x, y, w, h);
        this.filled = false;
    }
    AtlasNode.prototype.pack = function (rect) {
        if (this.left !== null) {
            return this.left.pack(rect) || this.right.pack(rect);
        }
        // if atlas filled or wont fit
        if (this.filled || !rect.fitsIn(this.rect)) {
            return null;
        }
        // if this atlas has been filled
        if (rect.sameSizeAs(this.rect)) {
            this.filled = true;
            return this;
        }
        if ((this.rect.w - rect.w) > (this.rect.h - rect.h)) {
            this.left = new AtlasNode(this.rect.x, this.rect.y, rect.w, this.rect.h);
            this.right = new AtlasNode(this.rect.x + rect.w, this.rect.y, this.rect.w - rect.w, this.rect.h);
        }
        else {
            this.left = new AtlasNode(this.rect.x, this.rect.y, this.rect.w, rect.h);
            this.right = new AtlasNode(this.rect.x, this.rect.y + rect.h, this.rect.w, this.rect.h - rect.h);
        }
        return this.left.pack(rect);
    };
    return AtlasNode;
}());
exports.AtlasNode = AtlasNode;
var Atlas = (function () {
    function Atlas(canvas, options) {
        if (options === void 0) { options = {}; }
        this.tilepad = options.tilepad || false;
        this.canvas = canvas;
        this.context = canvas.getContext('2d');
        this._rootNode = new AtlasNode(0, 0, this.canvas.width, this.canvas.height);
        this._terminalNodes = {};
        this.invalidateUvIndices();
    }
    Atlas.prototype.pack = function (id, img) {
        this._checkId(id);
        return this._pack(id, this.tilepad ? createTiledImage(img) : img);
    };
    Atlas.prototype.expand = function (id, img) {
        this._checkId(id);
        this.invalidateUvIndices();
        return this._expand(id, this.tilepad ? createTiledImage(img) : img);
    };
    Atlas.prototype.index = function () {
        var _this = this;
        return Object.keys(this._terminalNodes).map(function (key) { return _this._terminalNodes[key].rect; });
    };
    ;
    Atlas.prototype.uv = function () {
        if (this._uvs)
            return this._uvs;
        this._uvs = this.buildUvIndex();
        return this._uvs;
    };
    ;
    Atlas.prototype.uv2 = function () {
        if (this._uvs2)
            return this._uvs2;
        this._uvs2 = this.buildUvIndex2();
        return this._uvs2;
    };
    ;
    Atlas.prototype.invalidateUvIndices = function () {
        this._uvs = null;
        this._uvs2 = null;
    };
    Atlas.prototype._checkId = function (id) {
        if (this._terminalNodes[id])
            throw new Error("Duplicated texture id " + id);
    };
    Atlas.prototype._pack = function (id, img) {
        var rect = new Rect_1.default(0, 0, img.width, img.height);
        var node = this._rootNode.pack(rect);
        if (!node)
            return null;
        this._ontoCanvas(id, img, node.rect);
        this._terminalNodes[id] = node;
        if (this._uvs)
            this._uvs[id] = makeUv(node, this.tilepad, this.canvas.width, this.canvas.height);
        if (this._uvs2)
            this._uvs2[id] = makeUv2(node, this.tilepad, this.canvas.width, this.canvas.height);
        return node;
    };
    Atlas.prototype._expand = function (id, img) {
        var rect = new Rect_1.default(0, 0, img.width, img.height);
        var backup = this.context.getImageData(0, 0, this.canvas.width, this.canvas.height);
        var right;
        if (this._rootNode.rect.w < this._rootNode.rect.h) {
            this.canvas.width = this._rootNode.rect.w + rect.w;
            right = new AtlasNode(this._rootNode.rect.w, 0, rect.w, this._rootNode.rect.h);
        }
        else {
            this.canvas.height = this._rootNode.rect.h + rect.h;
            right = new AtlasNode(0, this._rootNode.rect.h, this._rootNode.rect.w, rect.h);
        }
        this.context.putImageData(backup, 0, 0);
        var left = this._rootNode;
        this._rootNode = new AtlasNode(0, 0, this.canvas.width, this.canvas.height);
        this._rootNode.left = left;
        this._rootNode.right = right;
        return this._pack(id, img) ? this : this._expand(id, img);
    };
    ;
    Atlas.prototype.buildUvIndex = function () {
        var _this = this;
        var uvs = {};
        Object.keys(this._terminalNodes).map(function (id) {
            var node = _this._terminalNodes[id];
            uvs[id] = makeUv(node, _this.tilepad, _this.canvas.width, _this.canvas.height);
        });
        return uvs;
    };
    Atlas.prototype.buildUvIndex2 = function () {
        var _this = this;
        var uvs2 = {};
        Object.keys(this._terminalNodes).map(function (id) {
            var node = _this._terminalNodes[id];
            uvs2[id] = makeUv2(node, _this.tilepad, _this.canvas.width, _this.canvas.height);
        });
        return uvs2;
    };
    // if has an image and canvas, draw to the canvas as we go
    Atlas.prototype._ontoCanvas = function (id, img, rect) {
        this.context.clearRect(rect.x, rect.y, rect.w, rect.h);
        this.context.drawImage(img, rect.x, rect.y, rect.w, rect.h);
    };
    ;
    return Atlas;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Atlas;
//# sourceMappingURL=Atlas.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/voxeline/engine/~/texture-atlas/lib/Atlas.js
 ** module id = 1129
 ** module chunks = 0
 **/